import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    pattern: { type: String, default: "lowercase-alphanumeric-dash" }
  }

  connect() {
    this.sanitize()
  }

  sanitize() {
    const input = this.element
    const cursorPosition = input.selectionStart
    const originalValue = input.value
    let sanitizedValue = originalValue

    switch (this.patternValue) {
      case "lowercase-alphanumeric-dash":
        // Convert to lowercase and keep only letters, numbers, and dashes
        sanitizedValue = originalValue
          .toLowerCase()
          .replace(/[^a-z0-9-]/g, '')
        break
      default:
        sanitizedValue = originalValue
    }

    // Only update if the value changed
    if (sanitizedValue !== originalValue) {
      input.value = sanitizedValue

      // Restore cursor position, accounting for removed characters
      const removedChars = originalValue.length - sanitizedValue.length
      const newCursorPosition = Math.max(0, cursorPosition - removedChars)
      input.setSelectionRange(newCursorPosition, newCursorPosition)
    }
  }
}
